module.exports = __webpack_public_path__ + "static/media/brady_logo.aa745569.png";